import React, {Fragment, useContext, useState} from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { Autocomplete, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, TextField, Typography } from '@mui/material';
import { TimeLineOrdenComponent } from './TimeLine';
import { TEXT_BTN, TEXT_REPORT_WO} from '../Constants/Const';
import {TableComponent} from "../Global/AgGridTableComponent";
import {AuthContext} from "../Global/AuthContext";

const VALUE_DIALOG_INIT={
      statusDialog: false,
      dataDialog: null
}

function DialogWorkOrder({openDialog=false, handlingCloseDialog=null, dataRow=null}){

      const [materialSelected, setMaterialSelected] = useState([]);

      const [material, setMaterial] = useState(null);

      const [materialOption] = useState([]);

      const handlingSlectedMaterial = (event, value)=>{
            setMaterial(null);
            setMaterialSelected([
                  ...materialSelected,
                  {
                        ...value,
                        numer: materialSelected.length+1
                  }
            ])
      }

      const handlingRemoveChip = (idMaterial) =>{
      
            if(materialSelected.find(material => material.numer === idMaterial)){
                  
                  let new_material = materialSelected.filter(material => material.numer !== idMaterial);
                  
                  setMaterialSelected(new_material);
            }
      }

      return(
            <Dialog open={openDialog} onClose={handlingCloseDialog} maxWidth="lg">
                  <DialogTitle>
                        <Typography variant="h5" >Reporte de falla</Typography>
                  </DialogTitle>

                  <Divider/>

                  <DialogContent >
                        <Grid container spacing={2}>{dataRow.name}
                              <Grid item xs={4}>
                                    <TextField
                                          fullWidth
                                          variant="filled"
                                          margin="normal"
                                          disabled
                                          label="Taller"
                                          defaultValue={dataRow.taller?.label}
                                    />
                              </Grid>

                              <Grid item xs={4}>
                                    <TextField
                                          fullWidth
                                          variant="filled"
                                          margin="normal"
                                          disabled
                                          label="Servicio"
                                          defaultValue={dataRow.servicio?.label}
                                    />
                              </Grid>

                              <Grid item xs={4}>
                                    <TextField
                                          fullWidth
                                          variant="filled"
                                          margin="normal"
                                          disabled
                                          label="Fecha de entrada al taller"
                                          defaultValue={dataRow?.date}
                                    />
                              </Grid>

                              <Grid item xs={4}>
                                    <TextField
                                          fullWidth
                                          variant="filled"
                                          margin="normal"
                                          disabled
                                          label="Unidad"
                                          defaultValue={dataRow?.datosUnidad?.label}
                                    />
                              </Grid>

                              <Grid item xs={4}>
                                    <TextField
                                          fullWidth
                                          variant="filled"
                                          margin="normal"
                                          disabled
                                          label="Chofer que reporto"
                                          defaultValue={dataRow?.datosChofer?.label}
                                    />
                              </Grid>

                              <Grid item xs={4}>
                                    <TextField
                                          fullWidth
                                          variant="filled"
                                          margin="normal"
                                          disabled
                                          label="Mecanico 1"
                                          defaultValue={dataRow?.mecanico_1?.label}
                                    />
                              </Grid>

                              <Grid item xs={4}>
                                    <TextField
                                          fullWidth
                                          variant="filled"
                                          margin="normal"
                                          disabled
                                          label="Mecanico 2"
                                          defaultValue={dataRow?.mecanico_2?.label}
                                    />
                              </Grid>

                              <Grid item xs={4}>
                                    <TextField
                                          fullWidth
                                          variant="filled"
                                          margin="normal"
                                          disabled
                                          label="Descripcion"
                                          defaultValue={dataRow?.descripcion}
                                    />
                              </Grid>

                              <Grid item xs={12}>
                                    <Divider/>
                              </Grid>

                              <Grid item xs={materialSelected.length < 10? 6:12}>
                                    <Autocomplete
                                          disablePortal
                                          fullWidth
                                          options={materialOption}
                                          value={material}
                                          onChange={handlingSlectedMaterial}
                                          renderInput={(params) => <TextField {...params} label="Selecciona Material" /> }
                                    />
                              </Grid>

                              <Grid item xs={materialSelected.length < 5? 6:12}>
                                    {
                                          materialSelected.map((material, index)=>(
                                                <Chip key={`chip-${material.numer}-${material.label.replace(/\s/g, '-')}`}
                                                      label={material.label}
                                                      onDelete={()=>handlingRemoveChip(material.numer)}
                                                />
                                          ))
                                    }
                              </Grid>

                              <Grid item xs={4}>
                                    <Button variant="contained" color="error">
                                          <Typography  variant='button' onClick={()=>setMaterialSelected([])}>{TEXT_BTN.clear}</Typography>
                                    </Button>
                              </Grid>


                              <Grid item xs={12}>
                                    <Divider/>
                              </Grid>

                              <Grid item xs={12}>
                                    <TimeLineOrdenComponent select={1} />
                              </Grid>

                        </Grid>
                  </DialogContent>

                  <DialogActions>
                        <Button variant="contained" color="error" onClick={handlingCloseDialog}>
                              <Typography variant='button'>{TEXT_BTN.exit}</Typography>
                        </Button>
                        <Button variant="contained" color="error" onClick={handlingCloseDialog}>
                              <Typography variant='button'>{TEXT_BTN.cancel}</Typography>
                        </Button>
                        <Button variant="contained" color="success" onClick={handlingCloseDialog}>
                              <Typography variant='button'>{TEXT_BTN.accepted}</Typography>
                        </Button>
                  </DialogActions>

            </Dialog>
      );

}



export function WorkOrderComponent(){

      const {report} = useContext(AuthContext);

      const [showDialog, setShowDialog] = useState(VALUE_DIALOG_INIT);

  
      // Columnas de la tabla
      const columnDefs = [
            { headerName: 'ID', field: 'id', flex: 1 },
            // { headerName: 'Fecha', field: 'status', flex: 1 },
            { headerName: 'Taller', field: 'taller.label', flex: 1 },
            { headerName: 'Fecha entrada', field: 'date', flex: 1 },
            { headerName: 'Chofer que reporto', field: 'datosChofer.label', flex: 1 },
            { headerName: 'Unidad reportada', field: 'datosUnidad.label', flex: 1 },
            { headerName: 'Descripcion', field: 'descripcion', flex: 1 },
            { headerName: 'Mecanico 1', field: 'mecanico_1.label', flex: 1 },
            { headerName: 'Mecanico 2', field: 'mecanico_2.label', flex: 1 },
      ];
  
      return (
            <Fragment>

                  <TableComponent
                      titleTable={TEXT_REPORT_WO.title}
                      columnsTable={columnDefs}
                      rowsTable={report}
                      handlingDoubleClick={(event)=>setShowDialog(()=>({dataDialog: event.data, statusDialog:true}))}
                  />

                  {
                        showDialog.statusDialog?
                        <DialogWorkOrder
                              dataRow={showDialog.dataDialog}
                              openDialog={showDialog.statusDialog}
                              handlingCloseDialog={()=>setShowDialog(olsState=>({...olsState, statusDialog:false}))}
                        />:null
                  }

            </Fragment>
      );
}
